import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
  selector: 'esc-report-email-dialog',
  templateUrl: './report-email-dialog.component.html',
  styleUrls: ['./report-email-dialog.component.scss']
})
export class ReportEmailDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ReportEmailDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any
  ) { }

  public title: string = "Report Generation";
  public message: string = "An email will be sent once the report is generated.";

  ngOnInit() {
    if (this.data) {
      this.title = _.get(this.data, "title") ? _.get(this.data, "title") : this.title;
      this.message = _.get(this.data, "message") ? _.get(this.data, "message") : this.message;
    }
  }

}
